import { BrokersIdPage } from '@/features/brokers/components';
import { requirePermissions } from '@/shared/utils';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/brokers/$id/')({
  component: BrokersIdRoute,
  beforeLoad: async () => {
    const hasPermission = await requirePermissions(['parties.brokers.read']);
    if (!hasPermission) {
      throw redirect({ to: '/dashboard' });
    }
  },
});

function BrokersIdRoute() {
  return <BrokersIdPage />;
}
